import React from 'react'
import _ from 'lodash'

import {changes} from 'util/data'

import {Row, Col} from 'react-flexbox-grid'
import {Button, Modal} from 'antd'

import {Input} from 'forms'

import {DevicesStorage} from 'storage'

const maybeDuplicateNotification = ({types, $newType}) => {
   if (-1 !== _.indexOf(types, $newType)) {
      Modal.info({
         title:   'Type already exists',
         content: (
            <p>
               The type <em>{$newType}</em> already exists.
            </p>
         )
      })

      return false
   }

   return true
}

const maybeRemoveActiveNotification = (type, typedDevices) => {
   if (typedDevices[type] && 0 < typedDevices[type].length) {
      Modal.info({
         title:   'Type in use',
         content: (
            <p>
               The type <em>{type}</em> have {typedDevices[type].length} active devices.
               You can change the type of those devices to remove the type.
            </p>
         )
      })

      return false
   }

   return true
}

const Types = ({network, devices}, {patch, input, onChange}) => {
   const defaultType = _.get(patch, 'provision.type', network.provision.type),
      currentTypes = _.uniq(_.get(patch, 'types', []).concat(network.types)).sort(),
      typedDevices = _.groupBy(devices, 'type'),
      {added, removed} = changes(_.get(patch, 'types', network.types), network.types),
      addType = ev => {
         ev.preventDefault()

         if (!patch.$newType || false === maybeDuplicateNotification(patch)) {
            return
         }

         onChange(ev, {param: '$newType'}, undefined)
         onChange(ev, {param: 'types'}, _.uniq(currentTypes.concat([patch.$newType])))
      },
      removeType = (ev, type) => {
         console.log('ev', ev.target)
         if (false === maybeRemoveActiveNotification(type, typedDevices)) {
            return
         }

         onChange(ev, {param: 'types'}, _.without(currentTypes, type))
      }

   return (
      <div className="types" style={{clear: 'both'}}>
         <div className="pager-header">
            <h2>Types</h2>
         </div>

         <Row className="squarelist">
            {_.map(currentTypes, (type, idx) => {
               const isDefault = defaultType === type,
                  isAdded = -1 !== _.indexOf(added, type),
                  isRemoved = -1 !== _.indexOf(removed, type)
               let cssClasses = ['square']

               if (isDefault) {
                  cssClasses = cssClasses.concat(['default'])
               }

               if (isAdded) {
                  cssClasses = cssClasses.concat(['added'])
               } else if (isRemoved) {
                  cssClasses = cssClasses.concat(['removed'])
               } else {
                  cssClasses = cssClasses.concat(['unchanged'])
               }

               return (
                  <Col xs={4} className={cssClasses.join(' ')} key={idx}>
                     <h3>{type} {isDefault ? <sup>(default)</sup> : null}</h3>

                     <dl className="dl-horizontal dl-form">
                        <span>Active Device Count: </span>
                        <span>{(typedDevices[type] || []).length || 'None'}</span>
                     </dl>

                     <div className="buttons">
                        <Button
                           onClick={ev => onChange(ev, {param: 'provision.type'}, type)}
                           value={type}
                           type="ghost"
                           style={{display: isDefault || isRemoved ? 'none' : 'initial'}}
                           size="small"
                           disabled={isDefault}
                        >

                           Make default
                        </Button>

                        &nbsp;&nbsp;

                        {!isRemoved
                           ? <Button
                                onClick={ev => removeType(ev, type)}
                                size="small"
                                type="danger"
                                disabled={isDefault}
                                icon="close"
                                value={type}
                             >
                                Remove Type
                             </Button>
                           : null}

                        {isRemoved
                           ? <Button
                                onClick={ev =>
                                   onChange(ev, {param: 'types'}, currentTypes.concat(type))}
                                size="small"
                                type="default"
                                disabled={isDefault}
                                icon="close"
                                value={type}
                             >
                                Re-add Type
                             </Button>
                           : null}

                     </div>
                  </Col>
               )
            })}

            <Col xs={3} className="square add">

               <Row>
                  <Col xs>
                     <Input
                        feedback={null}
                        className="form-control input-sm"
                        param="$newType"
                        placeholder="New type name ..."
                     />
                  </Col>
                  <Col xs>
                     <Button onClick={addType} icon="plus" disabled={!patch.$newType}>
                        Add New Type
                     </Button>
                  </Col>
               </Row>
            </Col>
         </Row>
         <Row>
            <Col xs>
               <TypeChanges patch={patch} network={network} added={added} removed={removed} />
            </Col>
         </Row>
      </div>
   )
}

Types.propTypes = {
   network: React.PropTypes.object.isRequired,
   devices: React.PropTypes.array.isRequired
}

Types.contextTypes = {
   onChange: React.PropTypes.func,
   patch:    React.PropTypes.object,
   input:    React.PropTypes.object
}

const TypeChanges = ({patch, network, added, removed}) => {
   const provisioning = _.get(patch, 'provision.type', network.provision.type)

   console.log('patch', _.get(patch, 'provision.type'))
   console.log('ent', _.get(network, 'provision.type'))

   return (
      <div>
         {added.length ? <span>Adding {added.length} new type(s)</span> : null}
         {added.length && removed.length ? ', ' : null}
         {removed.length ? <span>Removing {removed.length} type(s)</span> : null}
         {added.length || removed.length ? '. ' : null}
         {network.provision.type !== provisioning
            ? <span>Making <em>{provisioning}</em> default type</span>
            : null}
      </div>
   )
}

TypeChanges.propTypes = {
   added:   React.PropTypes.array,
   removed: React.PropTypes.array,
   patch:   React.PropTypes.object,
   network: React.PropTypes.object
}

const WrappedTypes = ({network, ...rest}) =>
   (network
      ? <DevicesStorage nid={network.key} network={network} {...rest}>
           <Types network={network} />
        </DevicesStorage>
      : <div>waiting for network</div>)

WrappedTypes.propTypes = {
   network: React.PropTypes.object
}

export default WrappedTypes



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/overview/Types.jsx